(() => {
  // Only normalize plain-text markdown left in product descriptions. Rich HTML stays intact.
  function formatDescriptions(root = document) {
    root.querySelectorAll('.product__description p').forEach((paragraph) => {
      if (paragraph.querySelector(':not(br)')) return;
      const text = Array.from(paragraph.childNodes, (node) => node.nodeName === 'BR' ? '\n' : node.textContent).join('').trim();
      if (/^[^\p{L}\p{N}]*\*\*[^*]+\*\*$/u.test(text)) {
        const heading = document.createElement('h3');
        heading.className = 'pt-desc-title';
        heading.textContent = text.replace(/\*\*/g, '').replace(/^[^\p{L}\p{N}]+/u, '');
        paragraph.replaceWith(heading);
        return;
      }
      const lines = text.split(/\n/).map((line) => line.trim()).filter(Boolean);
      if (lines.length < 2 || !lines.every((line) => /^-\s+/.test(line))) return;
      const list = document.createElement('ul');
      list.className = 'pt-features';
      lines.forEach((line) => {
        const content = line.replace(/^-\s+/, '').replace(/^[^\p{L}\p{N}]+/u, '').replace(/\*\*/g, '');
        const item = document.createElement('li');
        const colon = content.indexOf(':');
        if (colon > 0 && colon < 80) {
          const label = document.createElement('strong');
          label.textContent = content.slice(0, colon + 1);
          item.append(label, document.createTextNode(content.slice(colon + 1)));
        } else item.textContent = content;
        list.append(item);
      });
      paragraph.replaceWith(list);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => formatDescriptions(), { once: true });
  else formatDescriptions();
  document.addEventListener('shopify:section:load', (event) => formatDescriptions(event.target));
  function titleLineCount(title) {
    return Math.round(title.getBoundingClientRect().height / parseFloat(getComputedStyle(title).lineHeight));
  }
  function lastTitleLineHasOneWord(title) {
    const walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
    const range = document.createRange();
    const characters = [];
    let lastTop = -Infinity;
    let node;
    while ((node = walker.nextNode())) {
      let offset = 0;
      for (const character of node.textContent) {
        range.setStart(node, offset);
        offset += character.length;
        range.setEnd(node, offset);
        const rect = Array.from(range.getClientRects()).find((item) => item.width > 0.01 && item.height > 0);
        if (!rect) continue;
        lastTop = Math.max(lastTop, rect.top);
        characters.push({ character, top: rect.top });
      }
    }
    const text = characters.filter((item) => Math.abs(item.top - lastTop) < 1).map((item) => item.character).join('');
    return text.trim().split(/\s+/u).filter((word) => /[\p{L}\p{N}]/u.test(word)).length === 1;
  }
  // Keep the existing scale, then resolve near-threshold wraps without shrinking every title.
  function fitProductTitles() {
    document.querySelectorAll('product-info[id^="MainProduct-"] .product__title > h1').forEach((title) => {
      if (!title.isConnected || !title.getClientRects().length || title.getBoundingClientRect().width <= 0) return;
      if (getComputedStyle(title).visibility === 'hidden') return;
      const tail = title.querySelector('.pt-title-tail');
      title.style.removeProperty('font-size');
      tail?.style.removeProperty('display');
      const rootSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const style = getComputedStyle(title);
      let size = parseFloat(style.fontSize);
      const floor = 2.2 * rootSize;
      const lineRatio = parseFloat(style.lineHeight) / size;
      if (![rootSize, size, lineRatio].every(Number.isFinite) || title.getBoundingClientRect().height <= 0) return;
      const setSize = (value) => title.style.setProperty('font-size', `${(value / rootSize).toFixed(4)}rem`, 'important');
      while (size > floor + 0.1 && title.getBoundingClientRect().height > size * lineRatio * 2 + 1) {
        size = Math.max(floor, size - 0.05 * rootSize);
        setSize(size);
      }
      if (tail) tail.style.display = 'inline';
      const naturalLines = titleLineCount(title);
      const candidate = Math.max(floor, size - Math.min(0.05 * rootSize, size * 0.02));
      if (naturalLines > 1 && candidate < size - 0.01) {
        const previousSize = title.style.getPropertyValue('font-size');
        const previousPriority = title.style.getPropertyPriority('font-size');
        setSize(candidate);
        if (titleLineCount(title) >= naturalLines) {
          if (previousSize) title.style.setProperty('font-size', previousSize, previousPriority);
          else title.style.removeProperty('font-size');
        }
      }
      const finalLines = titleLineCount(title);
      if (tail && finalLines > 1 && lastTitleLineHasOneWord(title)) {
        tail.style.display = 'inline-block';
        if (titleLineCount(title) > finalLines) tail.style.display = 'inline';
      }
    });
  }
  let resizeFrame;
  function scheduleFit() {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(fitProductTitles);
  }
  if (document.fonts) document.fonts.ready.then(scheduleFit);
  else scheduleFit();
  window.addEventListener('resize', scheduleFit, { passive: true });
  document.addEventListener('shopify:section:load', scheduleFit);
  document.addEventListener('product-info:loaded', scheduleFit);
  // The branded navigation uses a wider drawer range than Dawn's tablet breakpoint.
  const inlineNavigation = window.matchMedia('(min-width: 1600px)');
  inlineNavigation.addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('header-drawer[data-breakpoint="tablet"]').forEach((drawer) => {
      const details = drawer.querySelector('details');
      if (!details?.open || typeof drawer.closeMenuDrawer !== 'function') return;
      const summary = details.querySelector('summary');
      const destination = document.querySelector('.header__heading-link') || summary;
      drawer.closeMenuDrawer(event, destination);
      summary.setAttribute('aria-expanded', 'false');
    });
  });
})();
